import { createInstance } from 'i18next';
import { initReactI18next } from 'react-i18next';

import { isLocalDev } from '../util/env';

import { resources } from './translations';

export const i18nInstance = createInstance({
  resources: {
    fr: resources,
  },
  debug: isLocalDev,
  lng: 'fr',
  interpolation: {
    prefix: '[[__',
    suffix: '__]]',
    escapeValue: false,
  },
  react: { transWrapTextNodes: 'span' },
});

void i18nInstance.use(initReactI18next).init();

export type I18NFunnelNamespace = keyof (typeof resources)['funnel'];
